<template >

    <div class="product-page-con">

        <div class="primary-heading-con">
            <div class="flex-con is-grow sm-pad-lr">
                <div class="is-narrow">
                    <router-link class="button" :to="{ name : $ROUTES.PRODUCTS_INDEX }">
                        <span class="icon">
                            <i class="fa fa-arrow-circle-o-left"></i>
                        </span>
                    </router-link>
                </div>
                <div>
                    <div class="heading product-title m-n" v-html="product.title"/>
                </div>
            </div>
        </div>

        <loading v-if="loading">
            <document-title value="Loading Product..."></document-title>
        </loading>
        <div v-else>

            <document-title :value="product.title"></document-title>

            <div class="flex-con lg-pad-lr is-start small-as-blocks">

                <div class="images-col">
                    <div class="primary-image">
                        <img v-if="activeImage" :src="$srcOverwrite(activeImage.url)" class="image">
                        <div v-else class="no-image">
                            <i class="fa fa-image"></i>
                        </div>
                    </div>
                    <div
                        v-if="allImages.length"
                        class="additional-images"
                    >
                        <div
                            v-for="(img,i) in allImages"
                            :key="img.url"
                            class="image-con"
                            :class="{ 'active-image' : i === activeImageIndex }"
                            @mouseenter="activeImageIndex = i"
                        >
                            <img class="image" :src="$srcOverwrite(img.url)"/>
                        </div>
                        <template v-if="showAllProductImages">
                            <div
                                v-for="(img,i) in product.images"
                                :key="img.url"
                                class="image-con"
                                :class="{ 'active-image' : i + allImages.length === activeImageIndex }"
                                @mouseenter="activeImageIndex = i + allImages.length"
                            >
                                <img class="image" :src="$srcOverwrite(img.url)"/>
                            </div>
                        </template>
                        <div
                            v-if="selectedVariant.images.length && product.images.length"
                            class="image-con show-parent-images"
                            @click="toggleShowAllProductImages"
                        >
                            <div class="inner">
                                <div class="icon">
                                    <i class="fa fa-plus" :class="!showAllProductImages ? 'fa-plus' : 'fa-minus'"></i>
                                </div>
                                <div>Images</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="variant-container">

                    <div class="product-section">
                        <table class="table">
                            <tbody>
                                <tr v-if="showSku">
                                    <th scope="row">SKU</th>
                                    <td>{{product.sku}}</td>
                                </tr>
                                <tr v-if="product.primaryCategory">
                                    <th scope="row">Category</th>
                                    <td>
                                        <span v-html="product.primaryCategory.name"/>
                                        <span v-if="product.secondaryCategory">
                                                <i class="fa fa-angle-right"></i>
                                                <span v-html="product.secondaryCategory.name"/>
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="product.manufacturer">
                                    <th scope="row">Brand</th>
                                    <td v-html="product.manufacturer"/>
                                </tr>
                                <tr v-if="!allVariantOptions.length && selectedVariant.upc">
                                    <th scope="row">UPC</th>
                                    <td>{{selectedVariant.upc}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="allVariantOptions.length" class="product-section options-con">
                        <label class="soft-label">Available Options:</label>
                        <div
                            v-for="option in allVariantOptions"
                            :key="option.id"
                        >
                            <label class="label">{{option.name}}:</label>
                            <div
                                v-for="value in option.values"
                                :key="value.id"
                                class="tag is-medium m-h-xs m-b-md has-cursor-pointer"
                                :class="{'is-link' : value.selected , 'strikethrough' : !value.available }"
                                @click="selectOption(value)"
                            >
                                {{value.value}}
                            </div>
                        </div>
                    </div>

                    <div class="product-section">

                        <div v-if="allVariantOptions.length">
                            <label class="soft-label m-b-sm">Selected Option:</label>

                            <div class="flex-con xs-pad-lr">
                                <div>
                                    <label class="soft-label is-smaller">SKU:</label>
                                </div>
                                <div class="soft-value">
                                    {{selectedVariant.sku}}
                                </div>
                            </div>

                            <div class="flex-con xs-pad-lr m-t-xs" v-if="selectedVariant.upc">
                                <div>
                                    <label class="soft-label is-smaller">UPC:</label>
                                </div>
                                <div class="soft-value">
                                    {{selectedVariant.upc}}
                                </div>
                            </div>
                        </div>

                        <div class="flex-con is-grow sm-pad-lr prices-con">
                            <div>
                                <label class="label">Price</label>
                                <money :value="selectedVariant.price" or="N/A" class="heading"></money>
                            </div>
                            <div class="has-text-centered">
                                <label class="label">MSRP</label>
                                <money :value="selectedVariant.msrp" or="N/A" class="heading"></money>
                            </div>
                            <div class="has-text-right">
                                <label class="label">MAP</label>
                                <money :value="selectedVariant.map" or="N/A" class="heading"></money>
                            </div>
                        </div>
                        <div class="flex-con is-grow sm-pad-lr prices-con">
                            <div>
                                <label class="label">Shipping Cost</label>
                                <money :value="selectedVariant.estimatedShippingCost" or="N/A" class="heading"></money>
                            </div>
                            <div>
                                <label class="label">Dropship Fee</label>
                                <money :value="selectedVariant.estimatedDropshipFee" or="N/A" class="heading"></money>
                            </div>
                            <div></div>
                        </div>
                    </div>

                    <div v-if="showCheckout" class="product-section">
                        <div class="flex-con sm-pad-lr is-end">
                            <div>
                                <label v-if="showQuantity" class="soft-label">Qty: ({{selectedVariant.quantity}} available) </label>
                                <label v-else class="soft-label">Qty:</label>
                                <div class="quantity">
                                    <input
                                        class="input"
                                        :disabled="selectedVariant.quantity === 0 && !allowBackorders"
                                        @blur="selectedQuantity = selectedQuantity < 1 ? 1 :  (allowBackorders ?  selectedQuantity : (selectedVariant.quantity < selectedQuantity ? selectedVariant.quantity : selectedQuantity))"
                                        v-model.number="selectedQuantity"
                                        type="number"
                                        :min="0"
                                        :max="allowBackorders ? selectedQuantity : selectedVariant.quantity"
                                        :default = "1"
                                    >
                                </div>
                            </div>
                            <div class="is-uppercase">
                                <add-to-cart-button
                                    v-if="(selectedVariant.quantity && selectedQuantity > 0) || allowBackorders"
                                    :product-id="selectedVariant.dealerProductId"
                                    :variant-id="selectedVariant.id"
                                    :available-quantity="selectedVariant.quantity"
                                    :quantity="selectedQuantity"
                                    class="is-rounded"
                                />
                                <div v-else class="button is-block-button is-static">
                                    <span v-if="selectedVariant.quantity === 0">
                                        Out Of Stock
                                    </span>
                                    <span v-else>
                                        At Least 1 Required
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="about">
                <div class="heading-con">
                    <h2 class="heading">About This Product</h2>
                </div>
                <div v-if="product.description" class="desc" v-html="product.description"></div>
                <div v-else>
                    <i>No Description is available for this product</i>
                </div>
                <div v-if="selectedVariant.description" class="attr">
                    <div class="attr-header is-size-4">Additional Details</div>
                    <div  class="desc" v-html="selectedVariant.description"></div>
                </div>
                <div class="attr">
                    <div class="attr-header is-size-4">Product attributes</div>
                    <div v-if="product.attributes.length" class="attr-attributes">
                        <div
                            v-for="attribute in product.attributes"
                            :key="attribute.id"
                        >
                            <div v-if="attribute.name !== attribute.value" class="tags has-addons">
                                <span class="tag is-medium">
                                    {{attribute.name}}
                                </span>
                                <span class="tag is-medium is-primary">
                                    {{attribute.value}}
                                </span>
                            </div>
                            <div v-else class="tags">
                                <span class="tag is-medium">
                                    {{attribute.value}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <i v-else>No attributes are available for this product</i>
                </div>

                <!--custom fields start-->
                <div class="attr">
                    <div class="attr-header is-size-4">Product Custom Attributes</div>
                    <div v-if="product.customFields.length" class="attr-attributes">
                        <div
                            v-for="customField in product.customFields"
                            :key="customField.id"
                        >
                            <div v-if="customField.name !== customField.value" class="tags has-addons">
                                <span class="tag is-medium">
                                    {{customField.name}}
                                </span>
                                <span class="tag is-medium is-primary">
                                    {{customField.value}}
                                </span>
                            </div>
                            <div v-else class="tags">
                                <span class="tag is-medium">
                                    {{customField.value}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <i v-else>No Custom Attributes are available for this product</i>
                </div>
                <!--custom fields end-->

            </div>

        </div>
    </div>

</template>

<script>
import _ from 'underscore';

import ProductsApi from '../../api/Products';
import AddToCartButton from "../../components/products/AddToCartButton";
import AccountSettingsMixin from "../../mixins/AccountSettingsMixin";

export default {
    name : "ViewVirtual",
    components : {
        AddToCartButton
    },
    mixins : [AccountSettingsMixin],
    data() {
        return {
            loading : true,
            productId : Number.parseInt(this.$route.params.id),
            product : {},
            activeImageIndex : 0,
            selectedVariant : {},
            selectedOptionValues : {}, //will keep a map of option id to selected option
            selectedQuantity : 1,
            showAllProductImages : false,
        }

    },
    computed : {
        optionValueCounts() {
            return _.chain(this.product.variants)
                .map(variant =>  variant.options)
                .flatten()
                .groupBy(variant => variant.virtualProductOptionId)
                .mapObject(variant => _.countBy(variant, 'value'))
                .value();
        },
        allImages() {
            return this.selectedVariant && this.selectedVariant.images && this.selectedVariant.images.length
                ? this.selectedVariant.images
                : this.product.images;
        },
        activeImage () {
            if(this.allImages[this.activeImageIndex]) {
                return this.allImages[this.activeImageIndex];
            }
            return this.product.images[this.activeImageIndex - this.allImages.length];
        },
        uniqueOptions() {
            return _.chain(this.product.variants)
                .pluck('options')
                .flatten()
                .map(variantOption => {
                    return {
                        value : variantOption.value,
                        optionId : variantOption.dealerProductOptionId
                    }
                })
                .uniq(option => {
                    //concat the two together as a key to be used for identifying uniqueness
                    return option.optionId + '_' + option.value;
                })
                .value();
        },
        allVariantOptions() {
            let that = this;

            //get references to changeable objects that change this property, in order to always trigger the change
            var selectedOptionValues = this.selectedOptionValues;

            return _.map(this.product.options, function(option) {
                let variantOptions = _.map(_.where(that.uniqueOptions, { optionId : option.id }), variantOption => {
                    let selected = that.isSelectedVariantOption(selectedOptionValues, variantOption);
                    let available = selected ? true : that.isCompatibleWithOtherSelections(option.id, variantOption.value);
                    return {
                        value : variantOption.value,
                        optionId : option.id,
                        selected : selected,
                        available : available
                    }
                });

                return {
                    id : option.id,
                    name : option.name,
                    values : variantOptions
                }
            });
        },
        showSku () {
            return this.$store.state.dealer_portal.settings['show_sku'];
        },
        showQuantity () {
            return this.$store.state.dealer_portal.settings['show_quantity'];
        },
        channelId(){
            return this.$getDealer().channelId;
        },
        allowBackorders () {
            return this.$getSessionContext().allowBackorders;
        },
    },
    beforeMount() {
        this.loadProduct();
    },
    methods : {
        loadProduct() {
            ProductsApi.getProduct(this.productId).then(response => {
                this.product = response.data;
                if (this.product.variants && this.product.variants.length > 0) {
                    const inStock = this.product.variants.filter(v => v.quantity > 0);
                    this.selectVariantId(
                        inStock.length
                            ? inStock[0].id
                            : this.product.variants[0].id
                    );
                }
                this.loading = false;
            });
        },
        selectVariantId(variantId) {
            this.selectedVariant = _.findWhere(this.product.variants, { id : variantId});
            this.activeImageIndex = 0;
            if(this.selectedVariant.quantity === 0){
                this.selectedQuantity = 1;
            }

            let groupedVariantOptions =_.groupBy(this.selectedVariant.options, function(variantOption) {
                return variantOption.dealerProductOptionId;
            });
            Object.values(groupedVariantOptions).forEach(group => {
                if (group.length == 1) {
                    let optionValue = group[0];
                    this.$set(this.selectedOptionValues, optionValue.dealerProductOptionId, optionValue.value);
                }
            });
        },
        selectOption(option) {
            var that = this;
            //if a variant is selected, and the selected variant does not have access to this option, then deselect the variant and change the selected image
            if (this.selectedVariant && this.selectedVariant.id && !this.hasOptionValue(this.selectedVariant, option.id, option.value)) {
                this.selectedVariant = {};
                this.activeImageIndex = 0;
            }
            this.$set(this.selectedOptionValues, option.optionId, option.value);
            that.removeNoLongerAvailableOptions(option.optionId, option.value);

            //loop through all options, if only one available option exists at a level that has no selections, select it
            this.allVariantOptions.forEach(variantOption => {
                var availableOptionsNotSelected = _.filter(variantOption.values, optionValue =>
                    !this.selectedOptionValues[variantOption.id] && optionValue.available
                );
                if (availableOptionsNotSelected.length === 1) {
                    this.selectOption(availableOptionsNotSelected[0]);
                }
            })

            let everyOptionIsSelected = this.allVariantOptions.length == Object.keys(this.selectedOptionValues).length;
            if (everyOptionIsSelected) {
                let variantsThatFit = _.filter(that.product.variants, function(variant) {
                    return _.every(variant.options, function (variantOption) {
                        let selectedValue = that.selectedOptionValues[variantOption.dealerProductOptionId];
                        return selectedValue && selectedValue === variantOption.value;
                    })
                });
                //if only one variant applies, select it
                if (variantsThatFit.length === 1) {
                    that.selectVariantId(variantsThatFit[0].id);
                }
            }
        },
        //will return whether has a variant has an option value, such as whether this shirt is large after clicking large
        hasOptionValue(variant, optionId, optionValue) {
            return variant && variant.options && variant.options && _.some(variant.options, function(option) {
                return option.dealerProductOptionId == optionId && option.value === optionValue;
            });
        },
        isSelectedVariantOption(selectedOptionValues, option) {
            let applicableOptionValue = selectedOptionValues[option.optionId];
            return applicableOptionValue && applicableOptionValue === option.value;
        },

        //look for one other option that was selected that is no longer selectable in combination with the selection that was just made
        removeNoLongerAvailableOptions(selectedOptionId, selectedOptionValue) {
            var that = this;
            for (let previousOptionId in this.selectedOptionValues) {
                let previousOptionValue  = this.selectedOptionValues[previousOptionId];

                let isAvailable =  _.some(this.product.variants, function(variant) {
                    return that.hasOptionValue(variant, selectedOptionId, selectedOptionValue) && that.hasOptionValue(variant, previousOptionId, previousOptionValue);
                });
                if (!isAvailable) {
                    this.$delete(this.selectedOptionValues, previousOptionId.toString());
                }
            }
        },

        //returns whether or not this option id, value combination can be combined with previous selections
        //example, return whether or not we can pick a blue shirt knowing that is large, when we may only have large red shirts and medium red or blue shirts
        isCompatibleWithOtherSelections(optionId, optionValue) {
            var that = this;
            for (let previousOptionId in this.selectedOptionValues) {
                if (previousOptionId == optionId) {
                    continue;
                }

                let previousOptionValue  = this.selectedOptionValues[previousOptionId];
                let variantExists = _.some(this.product.variants, function(variant) {
                    return that.hasOptionValue(variant, previousOptionId, previousOptionValue) && that.hasOptionValue(variant, optionId, optionValue);
                });
                if (!variantExists) {
                    return false;
                }
            }
            return true;
        },

        toggleShowAllProductImages () {
            if(!this.showAllProductImages) {
                this.showAllProductImages = true;
                this.activeImageIndex = this.allImages.length;
            } else {
                this.showAllProductImages = false;
                this.activeImageIndex = 0;
            }
        },
    },

}



</script>
<style lang="scss" scoped>

    @import '../../assets/css/_theme';


    .primary-heading-con {
        border-bottom:1px solid $grey-lighter;
        padding-bottom:20px;
        margin-bottom:20px;
    }

    .product-page-con {
        min-height:100%;
    }

    .images-col {
        text-align:center;
        width:66.66%;
        .primary-image {
            height:500px;
            .no-image {
                height:500px;
                padding-top:75px;
                .fa {
                    color:$grey-lighter;
                    font-size: 180px;
                }
            }
            img {
                max-width:500px;
                max-height:500px;
            }
        }
        .additional-images {
            display:flex;
            flex-wrap:nowrap;
            overflow-x:auto;
            .image-con {
                flex:0 0 auto;
                cursor:pointer;
                border-bottom:2px solid $white;
                padding:10px 0;
                width:100px;
                &.active-image {
                    border-bottom:2px solid $link;
                }
                &.show-parent-images {
                    background-color:lighten($link, 55);
                    color:lighten($link, 25);
                    border-radius:5px;
                    height:75px;
                    margin:15px 10px;
                    padding:4px 8px;
                    width:60px;
                    font-size:12px;
                    &:hover {
                        background-color:lighten($link, 50);
                        color:lighten($link, 20);
                    }
                    .inner {
                        margin-top:15px;
                    }
                }
                img {
                    max-width:85px;
                    max-height:85px;
                    margin:0 auto;
                }
            }
        }
    }

    .variant-container {
        width:33.33%;
        & > .product-section {
            padding:20px 0;
            border-top:1px solid $grey-lighter;
            &:first-child {
                padding-top:0px;
                border-top:none;
            }
        }
    }

    .strikethrough {
        position: relative;
        &:before {
            position: absolute;
            content: "";
            left: 0;
            top: 50%;
            right: 0;
            border-top: 1px solid;
            border-color: inherit;
            transform: rotate(-15deg);
        }
    }

    .product-title {
        font-size:22px;
        line-height:24px;
    }

    .options-con {
        & > div {
            &:not(:first-child) {
                margin-top:10px;
            }
        }
    }

    .prices-con {
        margin-top:20px;
        .heading {
            font-size:20px;
            font-weight:bold;
            margin:0;
        }
    }

    .soft-label {
        display:block;
        color:$grey-light;
        font-size:14px;
        &.is-smaller {
            font-size:12px;
        }
    }

    .soft-value {
        font-size:12px;
        color:$grey;
    }

    .select.quantity {
        margin-top:4px;
        select {
            border-top:none;
            border-left:none;
            border-right:none;
            border-bottom:2px solid $warning;
            border-radius:0;
        }
    }

    .about {
        margin: 40px 0;

        .heading-con {
            border-bottom: 1px solid $grey-lighter;
            padding-bottom: 10px;
            margin-bottom: 20px;

            .heading {
                margin: 0;
                font-size: 22px;
            }
        }
        /deep/ .desc {
            ul {
                margin-left:12px;
                list-style: disc !important;
            }
            h3{
                margin-left:0px;
                margin-top: 10px;
                margin-bottom: 10px;
                font-weight: bold;
            }
            p{
                margin-top : 10px;
            }
        }

        .attr {

            .attr-header {
                text-transform: uppercase;
                margin-top: 40px;
                padding-bottom: 10px;
            }

            .attr-attributes {
                display: flex;
                flex-wrap: wrap;
                align-items: baseline;

                b {
                    margin-right: 10px;
                }
                .tags {
                    margin-right: 12px;
                }
                .tags:last-child {
                    margin-bottom: 1rem;
                }
                .tag:not(body).is-primary {
                    background-color: $blue;
                }
            }
        }
    }


</style>
